import { createPolymorphicComponent } from '@mantine/core';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { cloneStyled } from '@utils/cloneStyled';
import { forwardRef } from 'react';
import styled from 'styled-components';
import Text, { TextProps } from './Text';

const StyledAnchor = cloneStyled(
  Text,
  styled(Text)<TextProps>`
    &:hover {
      color: ${({ textColor }) => COLORS_FLAT[textColor || 'b401']};
    }
  `,
);
function AnchorTextBase(props: TextProps, ref: React.Ref<HTMLAnchorElement>) {
  return <StyledAnchor textColor="b401" {...props} component="a" ref={ref} />;
}

const AnchorText = createPolymorphicComponent<'a', TextProps>(
  forwardRef(AnchorTextBase),
);

export { AnchorText };
